<div class="side-bar-component" *ngIf="show" [ngClass]="{'show': show,'hidden' : !show}">
  <div class="d-flex justify-content-between align-items-center pb-px-24">
    <mat-label class="fs-20 fw-7" *ngIf="title">{{title}}</mat-label>
    <svg-icon (click)="closeSideBar()" src="/assets/icons/close-modal-primary.svg"
class="cursor-pointer"></svg-icon>
  </div>
    @for (item of component; track $index) {
      <ng-container *ngComponentOutlet="item; inputs:{text:'test'}; injector: dynamicComponentInjector()"></ng-container>
    }
</div> 